import { BaseApi } from '../base-api';

import { type ISubscriptionDTO } from './interfaces';

export class SubscriptionApi extends BaseApi {
  protected readonly prefix = 'subscription';
  protected readonly passAppVersionHeader = true;

  fetch = () => this.get<ISubscriptionDTO>();
  updateCoupon = (coupon: string) => this.post('coupon', { coupon });
}
